import { CommissioningFormValues } from "nvent-web/types/CommissioningFormValues";
import { CommissionReportGeneration } from "nvent-web/types/CommissionReportGeneration";
import { DetailedProject } from "nvent-web/types/DetailedProject";
import { NewProjectFormValues } from "nvent-web/types/NewProjectFormValues";
import { Project } from "nvent-web/types/Project";
import { QuickReportGeneration } from "nvent-web/types/QuickReportGeneration";
import { SearchState } from "nvent-web/types/SearchState";

import Resource from "./Resource";
export interface ProjectFilters {
  search?: string;
  state?: SearchState;
}

export default class ProjectsResource extends Resource {
  getAll() {
    return this.http.get<Project[]>("projects");
  }
  create(data: NewProjectFormValues) {
    return this.http.post<Project>("projects", data);
  }
  getOne(id: number) {
    return this.http.get<DetailedProject>(`projects/${id}`);
  }
  updateOne(data: NewProjectFormValues, id: number) {
    return this.http.patch<DetailedProject>(`projects/${id}`, data);
  }
  remove(projectId: number) {
    return this.http.delete(`projects/${projectId}`);
  }
  sendCommission(projectId: number) {
    return this.http.post(`projects/${projectId}/commission`, {});
  }
  requestReportOnEmail(projectId: number, data: CommissioningFormValues) {
    return this.http.post(`/projects/${projectId}/commission_reports_emails`, data);
  }

  generateQuickReport(projectId: number) {
    return this.http.post(`/projects/${projectId}/quick_reports_generation`, {});
  }

  fetchQuickReportStatus(projectId: number) {
    return this.http.get<QuickReportGeneration>(`/projects/${projectId}/quick_reports_generation`);
  }

  generateCommissionReport(projectId: number) {
    return this.http.post(`/projects/${projectId}/commission_reports_generation`, {});
  }

  fetchCommissionReportStatus(projectId: number) {
    return this.http.get<CommissionReportGeneration>(`/projects/${projectId}/commission_reports_generation`);
  }

  downloadCommissionReport(url: string) {
    return this.http.get<BlobPart>(url, {
      responseType: "blob",
    });
  }

  async downloadBillOfMaterials(projectId: number) {
    return this.http.post<{ url: string }>(`projects/${projectId}/bill_of_materials`, {});
  }

  archive(projectId: number) {
    return this.http.post(`projects/${projectId}/archive`);
  }
  copy(projectId: number) {
    return this.http.post(`projects/${projectId}/duplicate`);
  }
  search({ state, search }: ProjectFilters) {
    return this.http.get("projects", {
      params: { state, q: search },
    });
  }
}
